(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.isTransparent = document.querySelector('.header-wrapper').classList.contains('transparent-header');

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (this.isTransparent) {
        if (scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          this.header.classList.remove('transparent-header');
          if (scrollTop > this.currentScrollTop) {
            this.header.classList.add('shopify-section-header-hidden');
          } else {
            this.header.classList.remove('shopify-section-header-hidden');
          }
        } else {
          this.header.classList.remove('scrolled-past-header', 'shopify-section-header-hidden');
          this.header.classList.add('transparent-header');
        }
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close()); 
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
  class luminLookBook extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScripts()
      this.querySelectorAll('.lumin-lookbook-point-list-item').forEach((elem) => {
        this.handleTooltip(elem)
      })
    } 
    
    async injectVendorScripts () {
      if (!window.FloatingUICore) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0')
        document.head.appendChild(script) 
      }
      if (!window.FloatingUIDOM) {
        await new Promise(r => setTimeout(r, 500))

        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1')
        document.head.appendChild(script)
      }
    }

    handleTooltip(elem) {
      const btn = elem.querySelector('button')
      const tooltip = elem.querySelector('.lumin-tooltip')

      function update() {
        window.FloatingUIDOM.computePosition(btn, tooltip, {
          middleware: [
            window.FloatingUIDOM.offset(0),
            window.FloatingUIDOM.autoPlacement()
          ],
        }).then(({x, y}) => {
          Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`,
          })
        })
      }

      function showTooltip() {
        tooltip.classList.add('show')
        update()
      }
      
      function hideTooltip() {
        setTimeout(() => {
          tooltip.classList.remove('show')
          tooltip.classList.add('hiding')
          setTimeout(() => {
            tooltip.classList.remove('hiding')
          }, 200)
        }, 100)
      }
      
      if (window.matchMedia("(pointer: coarse)").matches) {
        [
          ['mouseenter', showTooltip],
          ['mouseleave', hideTooltip],
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      } else {
        [
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      }
    }
  }
  customElements.define('lumin-lookbook', luminLookBook)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf-testimonials-faq-showcase"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initRfSection(root) {
    if (!root || root.dataset.rfInit === 'true') return;
    root.dataset.rfInit = 'true';

    /* ---------------- FAQ ---------------- */
    var faqWrap = root.querySelector('[data-rf-faq]');
    if (faqWrap) {
      var items = faqWrap.querySelectorAll('.rf-faq__item');

      function setPanelHeight(item, open) {
        var panel = item.querySelector('[data-rf-faq-panel]');
        var inner = item.querySelector('.rf-faq__answer-inner');
        if (!panel || !inner) return;
        panel.style.height = open ? inner.offsetHeight + 'px' : '0px';
      }

      items.forEach(function (item) {
        setPanelHeight(item, item.classList.contains('is-open'));
        var trigger = item.querySelector('[data-rf-faq-trigger]');
        if (!trigger) return;
        trigger.addEventListener('click', function () {
          var willOpen = !item.classList.contains('is-open');
          items.forEach(function (other) {
            other.classList.remove('is-open');
            var t = other.querySelector('[data-rf-faq-trigger]');
            if (t) t.setAttribute('aria-expanded', 'false');
            setPanelHeight(other, false);
          });
          if (willOpen) {
            item.classList.add('is-open');
            trigger.setAttribute('aria-expanded', 'true');
            setPanelHeight(item, true);
          }
        });
      });

      window.addEventListener('resize', function () {
        items.forEach(function (item) {
          if (item.classList.contains('is-open')) setPanelHeight(item, true);
        });
      });
    }

    /* ---------------- Testimonial slider ---------------- */
    var track = root.querySelector('[data-rf-slider-track]');
    var dotsWrap = root.querySelector('[data-rf-dots]');
    if (track) {
      var slides = Array.prototype.slice.call(track.querySelectorAll('[data-rf-slide]'));
      var dots = dotsWrap ? Array.prototype.slice.call(dotsWrap.querySelectorAll('[data-rf-dot]')) : [];

      function goToIndex(index, smooth) {
        var slide = slides[index];
        if (!slide) return;
        track.scrollTo({ left: slide.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      }

      function currentIndex() {
        var width = track.clientWidth || 1;
        return Math.round(track.scrollLeft / width);
      }

      function updateDots() {
        var idx = currentIndex();
        dots.forEach(function (dot, i) {
          var active = i === idx;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var idx = parseInt(dot.getAttribute('data-index'), 10) || 0;
          goToIndex(idx);
        });
      });

      var scrollTimer = null;
      track.addEventListener('scroll', function () {
        if (scrollTimer) window.cancelAnimationFrame(scrollTimer);
        scrollTimer = window.requestAnimationFrame(updateDots);
      }, { passive: true });

      window.addEventListener('resize', function () {
        goToIndex(currentIndex(), false);
        updateDots();
      });

      /* Mouse drag-to-scroll (touch/pen use native swipe + scroll-snap) */
      var isDragging = false;
      var dragStartX = 0;
      var dragStartScroll = 0;
      var dragMoved = false;

      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType && e.pointerType !== 'mouse') return;
        isDragging = true;
        dragMoved = false;
        dragStartX = e.clientX;
        dragStartScroll = track.scrollLeft;
        track.classList.add('is-dragging');
        track.setPointerCapture && track.setPointerCapture(e.pointerId);
      });

      track.addEventListener('pointermove', function (e) {
        if (!isDragging) return;
        var delta = e.clientX - dragStartX;
        if (Math.abs(delta) > 4) dragMoved = true;
        track.scrollLeft = dragStartScroll - delta;
      });

      function endDrag() {
        if (!isDragging) return;
        isDragging = false;
        track.classList.remove('is-dragging');
        goToIndex(currentIndex());
      }
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointerleave', endDrag);
      track.addEventListener('pointercancel', endDrag);

      track.addEventListener('click', function (e) {
        if (dragMoved) { e.preventDefault(); e.stopPropagation(); }
      }, true);

      /* Keyboard accessibility (left/right arrows), no visible arrow buttons */
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { goToIndex(Math.min(currentIndex() + 1, slides.length - 1)); }
        if (e.key === 'ArrowLeft') { goToIndex(Math.max(currentIndex() - 1, 0)); }
      });

      updateDots();
    }
  }

  function initAll() {
    document.querySelectorAll('.rf-showcase').forEach(initRfSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector ? e.target.querySelector('.rf-showcase') : null;
    if (root) {
      root.dataset.rfInit = 'false';
      initRfSection(root);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tlm-comparison-showcase"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initTlmSection(root) {
    if (!root || root.dataset.tlmInit === 'true') return;
    root.dataset.tlmInit = 'true';

    /* ---------------- FAQ ---------------- */
    var faqWrap = root.querySelector('[data-tlm-faq]');
    if (faqWrap) {
      var items = faqWrap.querySelectorAll('.tlm-faq__item');

      function setPanelHeight(item, open) {
        var panel = item.querySelector('[data-tlm-faq-panel]');
        var inner = item.querySelector('.tlm-faq__answer-inner');
        if (!panel || !inner) return;
        if (open) {
          panel.style.height = inner.offsetHeight + 'px';
        } else {
          panel.style.height = '0px';
        }
      }

      items.forEach(function (item) {
        setPanelHeight(item, item.classList.contains('is-open'));
        var trigger = item.querySelector('[data-tlm-faq-trigger]');
        if (!trigger) return;
        trigger.addEventListener('click', function () {
          var willOpen = !item.classList.contains('is-open');
          items.forEach(function (other) {
            other.classList.remove('is-open');
            var t = other.querySelector('[data-tlm-faq-trigger]');
            if (t) t.setAttribute('aria-expanded', 'false');
            setPanelHeight(other, false);
          });
          if (willOpen) {
            item.classList.add('is-open');
            trigger.setAttribute('aria-expanded', 'true');
            setPanelHeight(item, true);
          }
        });
      });

      window.addEventListener('resize', function () {
        items.forEach(function (item) {
          if (item.classList.contains('is-open')) setPanelHeight(item, true);
        });
      });
    }

    /* ---------------- Premium table scroll slider ---------------- */
    var scrollWrap = root.querySelector('[data-tlm-table-scroll]');
    var sliderEl = root.querySelector('[data-tlm-table-slider]');
    var track = root.querySelector('[data-tlm-table-slider-track]');
    var thumb = root.querySelector('[data-tlm-table-slider-thumb]');

    if (scrollWrap && sliderEl && track && thumb) {
      function updateThumb() {
        var scrollable = scrollWrap.scrollWidth > scrollWrap.clientWidth + 1;
        sliderEl.hidden = !scrollable;
        if (!scrollable) return;

        var trackWidth = track.clientWidth;
        var thumbWidth = Math.max(40, (scrollWrap.clientWidth / scrollWrap.scrollWidth) * trackWidth);
        var maxScroll = scrollWrap.scrollWidth - scrollWrap.clientWidth;
        var maxThumbOffset = Math.max(0, trackWidth - thumbWidth);
        var ratio = maxScroll > 0 ? scrollWrap.scrollLeft / maxScroll : 0;

        thumb.style.width = thumbWidth + 'px';
        thumb.style.transform = 'translateX(' + (ratio * maxThumbOffset) + 'px)';
      }

      scrollWrap.addEventListener('scroll', updateThumb, { passive: true });
      window.addEventListener('resize', updateThumb);
      updateThumb();

      var dragging = false;
      var startX = 0;
      var startScroll = 0;

      function pointerX(e) {
        return e.touches && e.touches.length ? e.touches[0].clientX : e.clientX;
      }

      function dragStart(e) {
        dragging = true;
        startX = pointerX(e);
        startScroll = scrollWrap.scrollLeft;
        document.addEventListener('mousemove', dragMove);
        document.addEventListener('touchmove', dragMove, { passive: false });
        document.addEventListener('mouseup', dragEnd);
        document.addEventListener('touchend', dragEnd);
      }
      function dragMove(e) {
        if (!dragging) return;
        if (e.cancelable) e.preventDefault();
        var deltaX = pointerX(e) - startX;
        var trackWidth = track.clientWidth;
        scrollWrap.scrollLeft = startScroll + (deltaX / trackWidth) * scrollWrap.scrollWidth;
      }
      function dragEnd() {
        dragging = false;
        document.removeEventListener('mousemove', dragMove);
        document.removeEventListener('touchmove', dragMove);
        document.removeEventListener('mouseup', dragEnd);
        document.removeEventListener('touchend', dragEnd);
      }

      thumb.addEventListener('mousedown', dragStart);
      thumb.addEventListener('touchstart', dragStart, { passive: true });

      track.addEventListener('click', function (e) {
        if (e.target === thumb) return;
        var rect = track.getBoundingClientRect();
        var clickRatio = (e.clientX - rect.left) / rect.width;
        scrollWrap.scrollLeft = clickRatio * scrollWrap.scrollWidth - scrollWrap.clientWidth / 2;
        updateThumb();
      });

      var revealOnScroll = sliderEl.getAttribute('data-reveal') === 'true';
      if (revealOnScroll && 'IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              sliderEl.classList.add('is-active');
              observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.2 });
        observer.observe(sliderEl);
      } else {
        sliderEl.classList.add('is-active');
      }
    }
  }

  function initAll() {
    document.querySelectorAll('.tlm-showcase').forEach(initTlmSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector ? e.target.querySelector('.tlm-showcase') : null;
    if (root) {
      root.dataset.tlmInit = 'false';
      initTlmSection(root);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-gallery"] && !Shopify.designMode) return;
  try {
    

class VideoGallery extends HTMLElement {
  constructor() {
    super();
    this.deferredMedia = this.querySelector(".video-gallery__media");
    this.videoPlaylist = this.querySelector(".video-gallery__thumbnails");
    this.activeVideoTitle = this.querySelector(".video-gallery__active-video-title");
    this.videoPlayer = null;

    this.handleVideoClick = this.handleVideoClick.bind(this);
  }

  connectedCallback() {
    this.videoPlaylist.addEventListener("click", this.handleVideoClick);
  }

  disconnectedCallback() {
    this.videoPlaylist.removeEventListener("click", this.handleVideoClick);
  }

  getVideoEmbedRef = () => {
    return document.querySelector('.video-gallery__embed');
  }

  getVideoPlayerRef = () => {
    return document.querySelector('.video-gallery__player');
  }

  clearExistingMedia = (type) => {
    
    const existingEmbed = this.getVideoEmbedRef();
    const existingPlayer = this.getVideoPlayerRef();

    if (type === 'video' && existingEmbed) {
      existingEmbed.remove();
    }

    if (type === 'embed' && existingPlayer) {
      existingPlayer.remove();
    }
  }

  handleVideoClick = (e) => {

    const thumbnailElement = event.target.closest(".video-gallery__thumbnail");
    if (!thumbnailElement) {
      console.error('Thumbnail element not found');
      return;
    }
    
    if (this.deferredMedia) {
      this.deferredMedia.loadContent(false);
    }

    const videoURL = thumbnailElement.dataset.videoUrl;
    const embedType = thumbnailElement.dataset.embedUrlType;
    const embedID = thumbnailElement.dataset.embedUrlId;
    const videoTitle = thumbnailElement.dataset.videoTitle;
    
    if (videoURL) {
        // Load video
        this.loadVideo(videoURL, videoTitle);
    } else if (embedType && embedID) {
        // Load embed
        this.loadEmbed(embedType, embedID, videoTitle);
    } else {
        console.error('Video URL or embed URL not found');
    }

    this.scrollToVideoPlayer(); 
  }

  // Function to scroll to the video player
  scrollToVideoPlayer = () => {
    if (!this.videoPlayer) {
      console.error('Video player element not found');
      return;
    }

    const videoPlayerPosition = this.videoPlayer.getBoundingClientRect().top + window.scrollY - 150;

    window.scrollTo({
      top: videoPlayerPosition,
      behavior: 'smooth'
    });
  }

  loadVideo = (videoURL, videoTitle) => {

    this.clearExistingMedia('video');

    // Get the video player
    this.videoPlayer = this.getVideoPlayerRef();

    if (!this.videoPlayer) {
      console.log('Video player element not found, creating it');
      this.videoPlayer = document.createElement('video');
      this.videoPlayer.classList.add('video-gallery__player');
      this.videoPlayer.setAttribute('playsinline', '');
      this.videoPlayer.setAttribute('autoplay', '');
      this.videoPlayer.setAttribute('controls', '');

      this.deferredMedia.appendChild(this.videoPlayer);
    }
    
    // Set video source and title
    this.videoPlayer.src = videoURL;
    this.videoPlayer.load();

    // Play the video
    this.videoPlayer.addEventListener('loadedmetadata', function loadedMetadataHandler() {
      this.videoPlayer.play()
        .then(() => {
          console.log('Video started playing');
          // Remove the event listener after playback starts
          this.videoPlayer.removeEventListener('loadedmetadata', loadedMetadataHandler);
        })
        .catch((error) => {
          console.error('Error playing video:', error);
        });
    }.bind(this));

    // Update the active video title
    this.activeVideoTitle.innerText = videoTitle;
  }

  loadEmbed = (embedType, embedID, videoTitle) => {

    if (embedType !== 'youtube' && embedType !== 'vimeo') {
      console.error('Invalid embed type');
      return;
    }

    this.clearExistingMedia('embed');

    const embedURL = (embedType == 'youtube') ? `https://www.youtube.com/embed/${embedID}?autoplay=1`: `https://player.vimeo.com/video/${videoId}?autoplay=1`;

    let embedElement = this.getVideoEmbedRef();

    if (!embedElement) {
      embedElement = document.createElement('iframe');
      embedElement.classList.add('video-gallery__embed');
      embedElement.setAttribute('allow', 'autoplay; encrypted-media');
      embedElement.setAttribute('allowfullscreen', '');
      this.deferredMedia.appendChild(embedElement);
    }
    
    embedElement.src = embedURL;
    embedElement.setAttribute('title', videoTitle);

    this.videoPlayer = embedElement;

    this.activeVideoTitle.innerText = videoTitle;
  }

}

customElements.define('video-gallery', VideoGallery);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-with-text"] && !Shopify.designMode) return;
  try {
    
  if (!window.__videoWithTextPlayInit) {
    window.__videoWithTextPlayInit = true;

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-video-play-button]');
      if (!button) return;
      var video = document.getElementById(button.getAttribute('data-video-play-button'));
      if (!video) return;
      video.play();
      button.style.display = 'none';
    });

    // 'play' and 'pause' do not bubble, so listen on the capture phase.
    document.addEventListener('play', function (event) {
      var video = event.target;
      if (!video || video.tagName !== 'VIDEO' || !video.id) return;
      var button = document.querySelector('[data-video-play-button="' + video.id + '"]');
      if (button) button.style.display = 'none';
      if (video.dataset.controlsOnPlay === 'true') {
        video.controls = true;
      }
    }, true);

    document.addEventListener('pause', function (event) {
      var video = event.target;
      if (!video || video.tagName !== 'VIDEO' || !video.id) return;
      video.controls = false;
      if (!video.ended) {
        var button = document.querySelector('[data-video-play-button="' + video.id + '"]');
        if (button) button.style.display = '';
      }
    }, true);
  }

  } catch(e) { console.error(e); }
})();
})();
